import React from 'react';
import PropTypes from 'prop-types';

import * as Modules from './individual/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleDispatcher = ({
    module,
    nextTypename,
    previousTypename,
    isInAccordion,
    ...props
}) => {

    if (!module?.__typename || typeof (Modules[module?.__typename.replace('Bva', '')]) === 'undefined') {
        console.warn(`Could not find module component ${module?.__typename}`);
        return null;
    } else {
        const ModuleComponent = Modules[module?.__typename.replace('Bva', '')];
        return (
            <ModuleComponent
                {...module}
                isInAccordion={isInAccordion}
                nextTypename={nextTypename}
                previousTypename={previousTypename}
                {...props} />
        );
    }
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleDispatcher.propTypes = {
    module: PropTypes.shape({
        __typename: PropTypes.string
    }),
    isInAccordion: PropTypes.bool,
    nextTypename: PropTypes.string,
    previousTypename: PropTypes.string
};

export default ModuleDispatcher;
